/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import { ItineraryRequest } from 'models/request/transport';
/**
 * Actions Types
 */
export enum IChangeTransportTypes {
  CHANGE_TRANSPORT_SET_DATA = '@request/CHANGE_TRANSPORT_SET_DATA',
  CHANGE_TRANSPORT_ADDRESS_OR_UNIT = '@request/CHANGE_TRANSPORT_ADDRESS_OR_UNIT',
  CHANGE_TRANSPORT_ITINERARY = '@request/CHANGE_TRANSPORT_ITINERARY',
  CHANGE_TRANSPORT_REQUEST = '@request/CHANGE_TRANSPORT_REQUEST',
  CHANGE_TRANSPORT_SUCCESS = '@request/CHANGE_TRANSPORT_SUCCESS',
  CHANGE_TRANSPORT_FAILURE = '@request/CHANGE_TRANSPORT_FAILURE',
}

/**
 * State Types
 */

export interface IChangeTransportData {
  fileTransportVoucherFront: File | null;
  numberVT: string | null;
  fileTransportVoucherBack: File | null;
  confirmedAddress: 'Sim' | 'Não';
  calledAddress?: string | null;
  unitConfirmed: 'Sim' | 'Não';
  calledUnit?: string | null;
  itineraryGoing: ItineraryRequest[] | [];
  itineraryBack: ItineraryRequest[] | [];
}

export interface IChangeTransportError {
  status?: number;
  message?: string;
}

export interface IChangeTransportState {
  readonly data: IChangeTransportData;
  readonly loading: boolean;
  readonly error: IChangeTransportError | null;
}
